import React, { useState } from "react";
import { Button } from "../Button";
import { useAddSchoolBlock } from "../../hooks/blockHooks/block.hooks";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { BlockForm } from "./BlockForm";

export const AddBlocks = () => {
  const dispatch = useDispatch();
  const [blockName, setBlockName] = useState("");
  const [schoolBranchId, setSchoolBranchId] = useState<number | null>(null);

  const { isLoading: isAddingBlock, mutate: addBlock } = useAddSchoolBlock({
    onSuccess: () => {
      setBlockName("");
      setSchoolBranchId(null);
      dispatch(setSuccessMessage("Block added successfully."));
    },
    onError: (err) => dispatch(setErrorMessage(parseApiError(err))),
  });

  const handleAddBlock = () => {
    if (!blockName) {
      return dispatch(setErrorMessage("Please enter block name"));
    }

    if (!schoolBranchId) {
      return dispatch(setErrorMessage("Please select branch."));
    }

    addBlock({
      name: blockName,
      school_branch_id: schoolBranchId as number,
    });
  };

  return (
    <div className="flex flex-col">
      <BlockForm
        blockName={blockName}
        setBlockName={setBlockName}
        schoolBranchId={schoolBranchId}
        onBranchSelect={(branchId: number) => {
          setSchoolBranchId(branchId);
        }}
      />

      <div>
        <Button loading={isAddingBlock} text="Save" onClick={handleAddBlock} />
      </div>
    </div>
  );
};
